import { Component, Inject, OnInit, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { LinkedGiftCard } from 'src/app/models/gift-card';
import { IMqttMessage, MqttService } from 'ngx-mqtt';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-gift-card-barcode-dialog',
  templateUrl: './gift-card-barcode-dialog.component.html',
  styleUrls: ['./gift-card-barcode-dialog.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GiftCardBarcodeDialogComponent implements OnInit, OnDestroy {
  barcodeImage: SafeUrl;
  card: LinkedGiftCard;
  private mqttSub: Subscription;
  balanceUpdated = false;

  constructor(
    private dialogRef: MatDialogRef<GiftCardBarcodeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private sanitizer: DomSanitizer,
    private mqttService: MqttService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.card = this.data.card;
    this.barcodeImage = this.sanitizer.bypassSecurityTrustUrl(
      'data:image/png;base64,' + this.card.barcode_image
    );
    this.subscribeToBalanceUpdates();
  }

  subscribeToBalanceUpdates() {
    const cardNumber = this.card.card_number;
    if (!cardNumber) return;

    const topic = `/giftcard/${cardNumber}/balance_update`;
    this.mqttSub = this.mqttService.observe(topic, { qos: 1 } as any)
      .subscribe((message: IMqttMessage) => {
        try {
          const payload = JSON.parse(message.payload.toString());
          if (payload.new_balance !== undefined) {
            this.card.balance = parseFloat(payload.new_balance);
            this.balanceUpdated = true;
            this.cdr.markForCheck();
          }
        } catch (e) {
        }
      });
  }

  getMaskedCardNumber(): string {
    if (this.card?.card_number && this.card.card_number.length >= 4) {
      return '****' + this.card.card_number.slice(-4);
    }
    return this.card?.card_number || '';
  }

  dismiss() {
    this.dialogRef.close(this.balanceUpdated ? this.card : null);
  }

  ngOnDestroy() {
    if (this.mqttSub) {
      this.mqttSub.unsubscribe();
    }
  }
}
